import styles from './Gallery.module.css'
import { useEffect } from "react"
import { GalleryImageType } from "./Gallery"
import { Row } from 'react-bootstrap'

interface fullscreenPropsInterface {
    visible: boolean
    onClose: () => void
    images: GalleryImageType[]
    imageIndex: number    
}

export default function Fullscreen(props: fullscreenPropsInterface) {
    const { visible, onClose, images, imageIndex } = props
    const image = images[imageIndex]

    useEffect(() => {
        if(images.length > 0) {
            const overflow = visible ? "hidden" : "unset"
            document.querySelector('body')!.style.overflow = overflow
        }
    }, [ images, visible ])

    if(images.length === 0 || !image) {
        return null
    }

    const overlayClassname = `${ styles.overlay } ${ visible ? styles.overlayFadeIn : styles.overlayFadeOut }`
    const fullscreenImageContainerClassName = `${ styles.fullscreenImageContainer } ${ visible ? styles.fullscreenImageContainerFadeIn : styles.fullscreenImageContainerFadeOut }`

    return (
        <Row className={ overlayClassname } onClick={() => onClose()}>
            <div className={ fullscreenImageContainerClassName }>
                <img
                    alt={ image.src }
                    src={ image.src }
                    className={ styles.fullscreenImage }
                    onClick={() => onClose()}
                />
            </div>
        </Row>
    )
}